var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#78A75A",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M321.67-361.67h67.59v-124.87h164.05v90.33L677.77-520 553.31-645.84v91.71H361.28q-16.31 0-27.96 11.8-11.65 11.8-11.65 28.7v151.96ZM480.24-86.23q-15.84 0-31.18-4.48-15.34-4.47-25.65-14.75L105.46-423.41q-10.28-10.27-14.75-25.58-4.48-15.31-4.48-31.15 0-15.83 4.98-31.15 4.97-15.32 14.59-24.97L423.74-854.2q10.27-10.29 25.55-15.43 15.27-5.14 31.48-5.14 16.2 0 31.19 4.64 14.99 4.64 25.3 14.93L855.2-537.26q10.29 10.27 14.93 25.14 4.64 14.86 4.64 30.92 0 16.54-5.14 31.84-5.14 15.31-15.43 25.62L536.26-105.8q-9.6 9.62-24.89 14.59-15.29 4.98-31.13 4.98ZM312.38-312.38l159.16 159.56q3.46 3.46 8.46 3.46 5 0 8.46-3.46l318.72-318.72q3.46-3.46 3.46-8.46 0-5-3.46-8.46L488.46-807.18q-3.46-3.46-8.46-3.46-5 0-8.46 3.46L152.82-488.46q-3.46 3.46-3.46 8.46 0 5 3.46 8.46l159.56 159.16ZM480-480Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.82ddb753697d0174387ae5f85b23612c.svg";
export { ForwardRef as ReactComponent };